// extracted by mini-css-extract-plugin
module.exports = {"container":"Quantity_container__01aa_","min":"Quantity_min__lF9fQ","max":"Quantity_max__OhSXc","num":"Quantity_num__nvTMH"};